/** In-flight promise for deduping POST /get-started/api/chat/create (e.g. remounts of ConversationalChat). */
let chatInitInflight = null

export function getChatInitInflight () {
  return chatInitInflight
}

export function setChatInitInflight (promise) {
  chatInitInflight = promise
}

export function clearChatInitInflight () {
  chatInitInflight = null
}
